import {TemplatesApiClient} from "./TemplatesApiClient";
import {ManifestDto} from "./ManifestDto";
import {JSONSchema} from "../../../json-schema";
import {SearchResultDto} from "./SearchResultDto";

const schema = {
    title: 'Formularz użytkownika',
    type: 'object',
    properties: {
        name: {
            type: 'string',
            title: 'Imię i nazwisko',
            pattern: '^[A-ZŻŹĆĄŚĘŁÓŃ][a-zżźćńółęąś]{2,}( [A-ZŻŹĆĄŚĘŁÓŃ][a-zżźćńółęąś]{2,})*$'
        },
        email: {
            type: 'string',
            pattern: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$'
        },
        role: {
            type: 'string',
            enum: ['admin', 'editor', 'viewer'],
            title: 'Rola'
        },
        age: {
            type: 'number'
        },
        tags: {
            type: 'array',
            title: 'Tagi',
            items: {
                type: 'string',
                enum: ['tech', 'sport', 'art']
            },
            minItems: 1
        },
        newsletter: {
            type: 'boolean',
            title: 'Zapisz do newslettera'
        },
        address: {
            type: 'object',
            title: 'Adres',
            properties: {
                street: {type: 'string'},
                zip: {
                    type: 'string',
                    title: 'Kod pocztowy',
                    pattern: '^[0-9]{2}-[0-9]{3}$'
                },
                city: {type: 'string'}
            },
            required: ['zip']
        }
    },
    required: ['name', 'email', 'role', 'address', 'tags']
} as JSONSchema;

const defaults = {
    name: 'Jan Kowalski',
    email: '',
    role: '',
    age: 30,
    newsletter: true,
    tags: ['tech'],
    address: {
        street: '',
        zip: '',
        city: ''
    }
};

export class StubApiClient implements TemplatesApiClient {
    async search(): Promise<SearchResultDto> {
        await this.simulateNetworkLatency();
        return {
            facets: [],
            manifests: [
                {
                    name: "Invoice",
                    description: "Invoice template",
                    tags: ["finance", "pdf"],
                    generator: {
                        image: "quick-app-v2:1.0.0"
                    },
                    version: "1.2.0"
                },
                {
                    name: "Contract",
                    description: "Contract template",
                    tags: ["legal", "doc"],
                    generator: {
                        image: "quick-app-v2:1.0.0"
                    },
                    version: "2.1.5"
                },
                {
                    name: "NDA",
                    description: "Non-disclosure agreement",
                    tags: ["confidential", "legal"],
                    generator: {
                        image: "quick-app-v2:1.0.0"
                    },
                    version: "3.0.0"
                }
            ]
        };
    }

    async getTemplateSchema(repoName: string, templateName: string, templateVersion?: string): Promise<JSONSchema> {
        return schema;
    }

    async getTemplateDefaults(repoName: string, templateName: string, templateVersion?: string): Promise<any> {
        return {}
    }

    private async simulateNetworkLatency(): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, 500)); // 500ms sztucznego opóźnienia
    }
}